import { BrandSettingsInterface } from 'modules/white-label/types/brand-settings'
import { getDashboardHostname } from 'modules/white-label/utils/dashboard-url'
import { getGlobalBrand } from 'modules/white-label/utils/global-brand'
import { sanitizeHostname } from './sanitize-hostname'

const resolveReferenceHostname = (brand?: BrandSettingsInterface | null): string => {
  if (brand?.dashboardHostname) {
    return sanitizeHostname(brand.dashboardHostname)
  }

  if (globalThis.window !== undefined) {
    const globalBrand = getGlobalBrand()

    if (globalBrand?.dashboardHostname) {
      return sanitizeHostname(globalBrand.dashboardHostname)
    }
  }

  return sanitizeHostname(getDashboardHostname(brand))
}

export const isDomainCustom = (domain?: string, brand?: BrandSettingsInterface | null): boolean => {
  if (!domain) {
    return false
  }

  const referenceHostname = resolveReferenceHostname(brand)
  const normalizedDomain = sanitizeHostname(domain)

  if (!referenceHostname || !normalizedDomain) {
    return false
  }

  return normalizedDomain !== referenceHostname
}

export const isCustomDomain = (brand?: BrandSettingsInterface | null): boolean =>
  (globalThis.window !== undefined && isDomainCustom(globalThis.location.hostname, brand)) || false

export const isCustomDomainByHostname = (
  hostname?: string,
  brand?: BrandSettingsInterface | null,
): boolean => isDomainCustom(hostname, brand)
